import { useCallback, useMemo, useState } from "react"

import ConfirmationModal, {
  ModalInfo,
} from "components/Modals/ConfirmationModal"
import { columns, sortByDefault } from "./columns"
import { css, cx } from "@emotion/css"
import { defaultSort, limitAndOffset } from "api/utils"
import { deleteClient, fetchClients } from "api/clientgroups"
import { queryCache, useMutation, useQuery } from "react-query"

import { ClientGroup } from "models/clientgroups"
import { ReactComponent as ClientsIcon } from "assets/icon-client.svg"
import { EmptyState } from "components/EmptyState"
import { Row } from "react-table"
import { Table } from "components/tables"
import { history } from "my-history"
import { useAuthenticated } from "providers/A12n"
import { useFeedback } from "components/FeedbackSnackbar"
import { useI18n } from "providers/I18n"
import { useLocationSearch } from "hooks/useLocationSearch"

export const styles = {
  createNew: css`
    padding-top: 1px;
    margin: 0 0.8ch;
    cursor: pointer;
  `,
}

const getRowProps = (row: Row<ClientGroup>) => {
  const id = row.original.id
  return {
    onClick: () => history.push(`/admin-client-groups/${id}/profile`),
  }
}

function GroupClients() {
  const { t } = useI18n()
  const ls = useLocationSearch()
  const [modalInfo, setModalInfo] = useState<ModalInfo>()
  const sendFeedback = useFeedback((s) => s.send)
  const { hasAuthority } = useAuthenticated()

  const params = ls
    .map(limitAndOffset)
    .map(defaultSort(sortByDefault))
    .toString()

  const q = useQuery(["client-groups", params], fetchClients)
  const { status, data } = q
  const clients = data?.data

  const [deletePlan] = useMutation(deleteClient, {
    onSuccess: () => {
      setModalInfo(undefined)
      queryCache.invalidateQueries(["client-groups", params])
    },
    onError: (e) => {
      setModalInfo(undefined)
      sendFeedback(t(e.message), "error")
    },
  })

  const onDelete = useCallback(
    (id: string) => {
      setModalInfo({
        title: t("client-groups.list.delete.title"),
        type: "primary_destructive",
        description: t("client-groups.list.delete.description"),
        submitLabel: t("client-groups.list.delete.action"),
        onSubmit: async () => await deletePlan(id),
      })
    },
    [deletePlan, t],
  )

  const isModalOpen = Boolean(modalInfo)

  // const filteredClients = clients?.flatMap((ac) => ac?.clients)
  // const associatedClients = useMemo(
  //   () =>
  //     filteredClients?.length
  //       ? filteredClients
  //           .map((c) => c?.name)
  //           .filter((v, i, a) => a.indexOf(v) === i)
  //       : [],
  //   [filteredClients]
  // )

  const filters = useMemo(() => {
    // const codeFilterOptions =
    //   clients?.map((c) => {
    //     return {
    //       value: c.code || "",
    //       label: <CheckListItemLabel secondary={""} primary={c.code} />,
    //     }
    //   }) || []
    // const statusFilterOptions =
    //   ["ACTIVE", "DEACTIVATED"]?.map((status) => {
    //     return {
    //       value: status || "",
    //       label: <CheckListItemLabel secondary={""} primary={status} />,
    //     }
    //   }) || []
    // const clientFilterOptions =
    //   associatedClients?.map((clientName) => {
    //     return {
    //       value: clientName || "",
    //       label: <CheckListItemLabel secondary={""} primary={clientName} />,
    //     }
    //   }) || []

    const options = [
      // {
      //   name: "code",
      //   label: t("filters.code"),
      //   options: codeFilterOptions,
      // },
      // {
      //   name: "status",
      //   label: t("filters.status"),
      //   options: statusFilterOptions,
      // },
      // {
      //   name: "clientName",
      //   label: t("filters.clientName"),
      //   options: clientFilterOptions,
      // },
    ] as any
    return options
  }, [])

  return (
    <>
      <Table<ClientGroup>
        id="client-groups-list-table"
        columns={columns(t, onDelete, hasAuthority)}
        data={clients ?? []}
        filters={filters ?? []}
        total={data?.total ?? 0}
        loading={status === "loading"}
        searchBy="search"
        getRowProps={getRowProps}
        noResults={
          <EmptyState
            title={t("client-groups.noresults.title")}
            icon={<ClientsIcon />}
            subtitle={
              hasAuthority(["AUTH_CREATE_SUPPLIER_GROUP"])
                ? t("client-groups.noresults.subtitle")
                : undefined
            }
          >
            {hasAuthority(["AUTH_CREATE_SUPPLIER_GROUP"]) ? (
              <span
                className={cx(
                  "BodyBody-1Primary-mainRegular",
                  styles.createNew,
                )}
              >
                {t("client-groups.add_new_subtitle")}
              </span>
            ) : null}
          </EmptyState>
        }
      />
      <ConfirmationModal
        open={isModalOpen}
        onCancel={() => setModalInfo(undefined)}
        {...modalInfo}
      />
    </>
  )
}

export default GroupClients
